const Missed = () => {
  return (
    <svg
      aria-hidden="true"
      width="3"
      height="16"
      viewBox="0 0 3 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.52209 1.12C2.52209 0.5005 2.02159 0 1.40209 0C0.782587 0 0.282087 0.5005 0.282087 1.12V10.08C0.282087 10.6995 0.782587 11.2 1.40209 11.2C2.02159 11.2 2.52209 10.6995 2.52209 10.08V1.12ZM1.40209 15.68C2.47981 15.68 3.15339 14.5133 2.61451 13.58C2.36444 13.1468 1.90226 12.88 1.40209 12.88C0.324362 12.88 -0.349214 14.0467 0.189661 14.98C0.439736 15.4132 0.901912 15.68 1.40209 15.68Z"
        fill="#E01E4E"
      />
    </svg>
  )
}

export default Missed
